/* Carrousel d'introduction.
 *
 * Une instance par section. Le defilement automatique s'interrompt des que le
 * visiteur s'approche (survol, focus) ou que l'onglet passe en arriere-plan, et
 * ne demarre pas du tout si le systeme demande moins d'animations.
 */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function HeroCarousel(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    this.index = 0;
    this.timer = null;
    this.paused = false;

    if (this.slides.length < 2) return;

    this.interval = parseInt(root.dataset.interval, 10) || 6000;
    this.autoplay = root.dataset.autoplay === 'true';
    root.style.setProperty('--hero-interval', this.interval + 'ms');

    this.bind();
    this.play();
  }

  HeroCarousel.prototype.bind = function () {
    var self = this;

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.goTo(parseInt(dot.dataset.index, 10));
        self.restart();
      });
    });

    var prev = this.root.querySelector('[data-hero-prev]');
    var next = this.root.querySelector('[data-hero-next]');
    if (prev) {
      prev.addEventListener('click', function () {
        self.goTo(self.index - 1);
        self.restart();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        self.goTo(self.index + 1);
        self.restart();
      });
    }

    // Les fleches du clavier ne prennent la main que si le focus est dans le
    // carrousel, pour ne pas confisquer la navigation de la page.
    this.root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        self.goTo(self.index - 1);
        self.restart();
      } else if (event.key === 'ArrowRight') {
        self.goTo(self.index + 1);
        self.restart();
      }
    });

    ['mouseenter', 'focusin'].forEach(function (type) {
      self.root.addEventListener(type, function () {
        self.pause();
      });
    });
    ['mouseleave', 'focusout'].forEach(function (type) {
      self.root.addEventListener(type, function () {
        self.play();
      });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        self.pause();
      } else {
        self.play();
      }
    });

    this.bindSwipe();
  };

  HeroCarousel.prototype.bindSwipe = function () {
    var self = this;
    var startX = null;

    this.root.addEventListener(
      'touchstart',
      function (event) {
        startX = event.touches[0].clientX;
      },
      { passive: true }
    );

    this.root.addEventListener(
      'touchend',
      function (event) {
        if (startX === null) return;
        var delta = event.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 45) {
          self.goTo(delta < 0 ? self.index + 1 : self.index - 1);
          self.restart();
        }
        startX = null;
      },
      { passive: true }
    );
  };

  HeroCarousel.prototype.goTo = function (target) {
    var count = this.slides.length;
    var next = ((target % count) + count) % count;

    this.root.dataset.heroAnimated = 'true';

    this.slides.forEach(function (slide, i) {
      var active = i === next;
      slide.classList.toggle('is-active', active);
      if (active) {
        slide.removeAttribute('inert');
      } else {
        slide.setAttribute('inert', '');
      }
    });

    this.dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === next);
      dot.setAttribute('aria-selected', i === next ? 'true' : 'false');
    });

    this.index = next;
  };

  HeroCarousel.prototype.play = function () {
    if (!this.autoplay || REDUCED.matches) return;
    this.paused = false;
    this.root.dataset.playing = 'true';
    if (this.timer) return;
    var self = this;
    this.timer = window.setInterval(function () {
      self.goTo(self.index + 1);
    }, this.interval);
  };

  HeroCarousel.prototype.pause = function () {
    this.paused = true;
    this.root.dataset.playing = 'false';
    window.clearInterval(this.timer);
    this.timer = null;
  };

  // Repart de zero apres une action manuelle : la diapositive choisie doit
  // s'afficher le temps complet, pas le reliquat du compte a rebours.
  HeroCarousel.prototype.restart = function () {
    this.pause();
    this.play();
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-hero-carousel]').forEach(function (root) {
      if (root.dataset.heroReady === 'true') return;
      root.dataset.heroReady = 'true';
      new HeroCarousel(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // L'editeur de theme remonte et redescend les sections sans recharger la page.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
